import { CentroCustoService } from "src/app/services/centro.custo.service";
import { CentroCusto } from "src/app/models/centrocusto.model";
import { AfterContentInit, Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";

import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { UsuarioService } from "src/app/services/usuario.service";
import { APP_SETTINGS } from "src/environments/environment";

@Component({
  selector: "app-centro-custo",
  templateUrl: "./centro-custo.component.html",
  styleUrls: ["./centro-custo.component.sass"],
})
export class CentroCustoComponent implements OnInit, AfterContentInit {
  public cadastrados: CentroCusto[] = [];
  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;
  public isLoading = false;

  public voids: string[] = [];
  public maxRowsVoids = 7;

  autorizacoes: UsuarioAutorizacoes = null;
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  constructor(
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private centroCustoService: CentroCustoService
  ) {}

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("centro-custo");
  }

  ngOnInit() {
    this.list();
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  private list() {
    this.isLoading = true;
    this.centroCustoService.getCentrosCustos().subscribe((response) => {
      this.cadastrados = response;
      this.isLoading = false;
      this.setVoids();
    });
  }

  public resetForm(): void {
    this.form = new FormGroup({
      id: new FormControl(0),
      nome: new FormControl("", [
        Validators.required,
        Validators.maxLength(40),
      ]),
      habilitado: new FormControl(true),
      codigo: new FormControl("", [Validators.required]),
    });
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    this.resetForm();
  }

  public read(id: number): void {
    this.reset();
    this.isProcessing = true;

    this.centroCustoService.get(id).subscribe(
      (centrocusto: CentroCusto) => {
        this.form.get("id").setValue(centrocusto.id);
        this.form.get("nome").setValue(centrocusto.nome);
        this.form.get("habilitado").setValue(centrocusto.habilitado);
        this.form.get("codigo").setValue(centrocusto.codigo);
        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public submit(): void {
    this.isProcessing = true;

    if (this.form.get("id").value === 0) {
      this.centroCustoService
        .isUniqueCentroCusto(this.form.get("nome").value)
        .subscribe(
          (isUniqueCentroCusto: boolean) => {
            if (isUniqueCentroCusto) {
              this.save();
            } else {
              this.form.get("nome").setErrors({ isNotUniqueCentroCusto: true });
              this.isProcessing = false;
            }
          },
          (error: any) => {
            this.showError(error);
          }
        );
    } else {
      this.save();
    }
  }

  public save() {
    this.centroCustoService.post(this.form.value as CentroCusto).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) {
        this.voids.push("");
      }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, {
      windowClass: "smModal",
      backdrop: "static",
    });
  }

  public delete(id: number, c: any): void {
    this.isProcessing = true;
    c("Close click");

    this.centroCustoService.delete(id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {
    // this.form.get('codigo').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error("Ocorreu um erro no servidor");
    }

    this.isProcessing = false;
  }
}
